module.exports = __webpack_public_path__ + "img/medical_physical_03.7f0d13a3.jpg";